import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  Link,
  Divider,
  Stack,
} from '@mui/material';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: '#1a1a2e',
        color: 'white',
        mt: 'auto',
        py: 6,
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={3} justifyContent="space-between">
          <Grid item xs={12} sm={12} md={5} lg={4}>
            <Typography variant="h5" gutterBottom fontWeight="bold" sx={{ color: '#4a9eff' }}>
              PartzFlow
            </Typography>
            <Typography variant="body2" sx={{ color: '#b0b0b0', lineHeight: 1.8, fontSize: '0.875rem', pr: 2 }}>
              PartzFlow MarketPlace - Your trusted source for electronic components and parts.
            </Typography>
          </Grid>

          <Grid item xs={12} sm={4} md={2} lg={2}>
            <Typography variant="h6" gutterBottom fontWeight="600" sx={{ mb: 2 }}>
              Products
            </Typography>
            <Stack spacing={1}>
              <Link href="#" variant="body2" sx={{ color: '#b0b0b0', textDecoration: 'none', '&:hover': { color: '#4a9eff' } }}>
                Resistors
              </Link>
              <Link href="#" variant="body2" sx={{ color: '#b0b0b0', textDecoration: 'none', '&:hover': { color: '#4a9eff' } }}>
                Capacitors
              </Link>
              <Link href="#" variant="body2" sx={{ color: '#b0b0b0', textDecoration: 'none', '&:hover': { color: '#4a9eff' } }}>
                Semiconductors
              </Link>
              <Link href="#" variant="body2" sx={{ color: '#b0b0b0', textDecoration: 'none', '&:hover': { color: '#4a9eff' } }}>
                Connectors
              </Link>
            </Stack>
          </Grid>

          <Grid item xs={12} sm={4} md={2} lg={2}>
            <Typography variant="h6" gutterBottom fontWeight="600" sx={{ mb: 2 }}>
              Support
            </Typography>
            <Stack spacing={1}>
              <Link href="#" variant="body2" sx={{ color: '#b0b0b0', textDecoration: 'none', '&:hover': { color: '#4a9eff' } }}>
                Help Center
              </Link>
              <Link href="#" variant="body2" sx={{ color: '#b0b0b0', textDecoration: 'none', '&:hover': { color: '#4a9eff' } }}>
                Contact Us
              </Link>
              <Link href="#" variant="body2" sx={{ color: '#b0b0b0', textDecoration: 'none', '&:hover': { color: '#4a9eff' } }}>
                Technical Support
              </Link>
              <Link href="#" variant="body2" sx={{ color: '#b0b0b0', textDecoration: 'none', '&:hover': { color: '#4a9eff' } }}>
                Returns
              </Link>
            </Stack>
          </Grid>

          <Grid item xs={12} sm={4} md={2} lg={2}>
            <Typography variant="h6" gutterBottom fontWeight="600" sx={{ mb: 2 }}>
              Company
            </Typography>
            <Stack spacing={1}>
              <Link href="#" variant="body2" sx={{ color: '#b0b0b0', textDecoration: 'none', '&:hover': { color: '#4a9eff' } }}>
                About Us
              </Link>
              <Link href="#" variant="body2" sx={{ color: '#b0b0b0', textDecoration: 'none', '&:hover': { color: '#4a9eff' } }}>
                Careers
              </Link>
              <Link href="#" variant="body2" sx={{ color: '#b0b0b0', textDecoration: 'none', '&:hover': { color: '#4a9eff' } }}>
                Privacy Policy
              </Link>
              <Link href="#" variant="body2" sx={{ color: '#b0b0b0', textDecoration: 'none', '&:hover': { color: '#4a9eff' } }}>
                Terms of Service
              </Link>
            </Stack>
          </Grid>
        </Grid>

        <Divider sx={{ my: 4, borderColor: 'rgba(255, 255, 255, 0.1)' }} />

        <Typography variant="body2" sx={{ color: '#b0b0b0' }} align="center">
          © {new Date().getFullYear()} PartzFlow MarketPlace. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;